export const holesList = new Array(18).fill('empty').map((_, index) => index + 1);
